exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".data{width:98%;margin:1%;border-radius:5px}.data td{padding:2px 15px}.data thead{font-weight:700}.data thead tr{background-color:#ccc}.data thead td{padding:10px 15px}.btr_isd_lii{border-botton:1px solid grey}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./app/views/parameters/parameters.css
// module id = 242
// module chunks = 0